import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/services/store.service';
import { EmailsListService } from '../services/email-list.service';

@Component({
  selector: 'lms-emails-list',
  templateUrl: './emails-list.component.html',
  styleUrls: ['./emails-list.component.scss'],
  providers: [EmailsListService]
})
export class EmailsListComponent implements OnInit {
  @Input() listId: string;
  @Input() options: any;
  public defaultOptions: any = { elementsName: 'emails.label', sort: '-created_at' };
  public listOptions: any;
  public dataSource: any;
  @Output() public hideSearch: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public emailsListService: EmailsListService,
    public router: Router,
    public translate: TranslateService,
    public titleService: Title
  ) {}

  public async ngOnInit() {
    this.listOptions = Object.assign({}, this.defaultOptions, this.options);
    this.listOptions.filters = { ...this.listOptions.filters };
    this.dataSource = await this.emailsListService.getDatasource(this.listId, this.listOptions);
    if (!this.dataSource.docs.length) {
      this.setSortableTable();
    }
  }

  public onDatasourceUpdate(dataSource): void {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }

  /**
   * Set the sort of columns
   * @private
   */
  private setSortableTable(): void {
    this.hideSearch.emit(true);
    this.dataSource.columns = this.emailsListService.getColumns({ timezone: this.options.timezone, sortable: false });
    StoreService.update(this.listId, this.dataSource);
  }
}
